export default {
  subHeadingColor: '',
};
